<template>
<div>
    <el-dialog top="5vh" :append-to-body="true" :visible.sync="dialogVisible" :width="element.options.remoteData.width" :title="element.options.remoteData.title">
        <el-form inline-message :model="searchList" v-if="element.options.remoteData.isSearch">
                <el-row :gutter="10">
                    <el-col :span="6" v-for="(val,idx) in element.options.remoteData.displayFieldList" :key="idx">
                            <el-form-item v-if="val.isSearch" :label="val.labelName" :prop="val.displayField" label-width="90px">
                                <el-input style="width:100%" size="mini" v-model="searchList[val.displayField]" :placeholder="val.disabled?'':'请输入'"></el-input>
                            </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mt5">
                        <el-button @click="searchBtn" type="primary" size="mini">搜索</el-button>  
                        <el-button @click="resetBtn" type="info" size="mini">重置</el-button>
                    </el-col>
                </el-row>
        </el-form>
        <el-table ref="vTable" :data="data"  tooltip-effect="dark" style="width: 100%" highlight-current-row border stripe row-key="id" @selection-change="selectTableData" height="400">
            <el-table-column type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope"><span>{{scope.$index+(page.currentPage - 1) * page.pageSize + 1}} </span></template>
            </el-table-column>
            <template v-for="(val,idx) in element.options.remoteData.displayFieldList">
                <el-table-column :label="val.labelName" :prop="val.displayField" :key="idx" :width="val.width" v-if="val.isShow"></el-table-column>
            </template>
        </el-table>
        <el-pagination v-if="element.options.remoteData.ispaging" background class="text-right pt10" @size-change="sizeChange" @current-change="currentChange" :current-page="page.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="page.pageSize" layout="total, sizes, prev, pager, next" :total="page.totalCount">
        </el-pagination>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="defineBtn">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>

export default {
    name: 'popupComponents',
    props: ['element','isChild'],
    data() {
        return {
            basic_url: Config.dev_url,
            dialogVisible: false,
            item: {},  //当前弹出框的配置信息
            data: [],  //表格数据
            page: {   //分页配置
                currentPage: 1,
                pageSize: 20,
                totalCount: 0
            },
            searchList: {}, //搜索条件
            selectData: [], //当前选中的数据
            detailInfo: {}, //主表详情信息
            childDataInfo:[], //子表所有的数据
            addobj:{},
        }
    },
    computed:{
        detailInfos(){
            return this.$store.state.detailInfo
        },
        currentuser(){
            return this.$store.state.currentuser
        }
    },
    methods: {
        sizeChange(val) {
            this.page.pageSize = val
            this.getData(this.item,'分页',this.searchList)
        },
        currentChange(val) {
            this.page.currentPage = val
            this.getData(this.item,'分页',this.searchList)
        },
        view(item,childData,obj) {
            this.selectData = []
            this.dialogVisible = true;
            this.item = item
            this.childDataInfo = childData
            this.addobj = obj
            this.getData(item)
            this.$nextTick(()=>{
                this.$refs.vTable.clearSelection()
            })
        },
        searchBtn() {
            this.getData(this.item,'',this.searchList)
        },
        resetBtn() {
            this.searchList = {}
            this.getData(this.item,'',this.searchList)
        },
        getData(item,str,searchList) {
            //处理查询条件
            var options = item.options.remoteData.options
            var obj = {}
            for (let key in searchList) {
                if (JSON.stringify(searchList) == "{}") {
                    delete obj[key]
                } else {
                    obj[key] = searchList[key]
                }
            }
            //查询条件处理
            for (var i = 0; i < options.length; i++) {
                if (!!options[i].key && !!options[i].value) {
                        if (options[i].isFixedValue) {
                            obj[options[i].key] = options[i].value
                        } else {
                            if(options[i].value.indexOf('currentuser:') !== -1){
                                obj[options[i].key] = this.currentuser[options[i].value.substr(options[i].value.indexOf('currentuser:')+12,options[i].value.length)]
                            }else{
                                obj[options[i].key] = this.detailInfos[options[i].value]
                            }
                        }
                }

                if (str != '分页') {
                    if (options[i].key == 'page' && !!options[i].value) {
                        this.page.currentPage = Number(options[i].value)
                    } else if (options[i].key == 'limit' && !!options[i].value) {
                        this.page.pageSize = Number(options[i].value)
                    }
                } else {
                    if (options[i].key == 'page' && !!options[i].value) {
                         obj[options[i].key] = this.page.currentPage
                    } else if (options[i].key == 'limit' && !!options[i].value) {
                        obj[options[i].key] = this.page.pageSize
                    }
                }
            }
            var str = ''
            for (let key  in obj) {
                str += key + '=' + obj[key] + '&'
            }

//            //处理复合条件设置
            if(!!item.options.remoteData.complexoptions)
            {
              item.options.remoteData.complexoptions.replace(/:[\S]+/g,function(res){
                return this.detailInfos[res];
              });
               var params=str+='where_condition='+item.options.remoteData.complexoptions;
            }
            else{
               var params = str.substring(0,str.length - 1);
            }

          var params = str.substring(0,str.length - 1);

            //数据来源：数据字典类型
            if (item.options.remote == 1) {
                if (!!item.options.dictionaryCode) {  //类型编码存在
                     var code = item.options.dictionaryCode
                     if (item.options.remoteData.methods == 'post') {
                         var url = Config.dev_url + '/api-user/dicts/findByCode?dict=' + code
                         this.$axios.post(url,obj).then((res)=>{
                             console.log(res,"弹出框数据 --- post")
                             this.data  = res.data.data
                             this.page.totalCount = res.data.count
                         })
                     }
                    //  else if(item.options.remoteData.methods == 'get'){
                    //         var url = Config.dev_url + '/api-user/dicts/findByCode?dict=' + code + '&' + params
                    //         this.$axios.get(url).then((res)=>{
                    //                 console.log(res,"弹出框数据 --- get")
                    //                 this.data  = res.data.data
                    //                 this.page.totalCount = res.data.count
                    //         })
                    //  }
                }
            //数据来源：远端数据
            } else if (item.options.remote == 2) {
                 if (item.options.remoteData.methods == 'post') {
                        var url = Config.dev_url + item.options.remoteData.url
                        this.$axios.post(url,obj).then((res)=>{
                            console.log(res,"弹出框远端数据 --- post")
                             this.data  = res.data.data
                             this.page.totalCount = res.data.count
                        })
                 } else if (item.options.remoteData.methods == 'get') {
                        var url = Config.dev_url + item.options.remoteData.url + '?' + params
                        this.$axios.get(url).then((res)=>{
                            console.log(res,"弹出框远端数据 --- get")
                            this.data  = res.data.data
                            this.page.totalCount = res.data.count
                        })
                 }
            }
        },
        //选中表格某条数据时触发
        selectTableData(val) {
            console.log(val)
            this.selectData = val;
        },
        //弹出框确定按钮点击
        defineBtn() {
            if (this.selectData.length == 0) {
                this.$message.warning('请先选择数据再进行操作');
                return;
            }
            var replaceFieldList = this.element.options.remoteData.displayFieldList;
            for(var i=0; i<this.selectData.length; i++){
                var obj = {}
                for(let key  in this.addobj){
                    obj[key] = this.addobj[key]
                }
                var selectItemData = this.selectData[i]
                for(var j=0; j<replaceFieldList.length; j++){
                    obj[replaceFieldList[j].replaceField] = selectItemData[replaceFieldList[j].displayField]
                }
                this.selectData[i] = obj
            }
            console.log(this.selectData,"最后选择的数据")
            this.$emit("updateBatch",this.selectData);
            this.dialogVisible = false;
        },
    }
}
</script>

<style>

</style>
